/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type OAuthProvider =
  | 'GOOGLE'
  | 'MICROSOFT';

export type RevokePlannerAccountThirdpartyOAuthCredentialsInput = {
  provider: OAuthProvider;
};

export type IssueMicrosoftOAuthUrlMutationVariables = Exact<{
  redirectUri: string;
}>;


export type IssueMicrosoftOAuthUrlMutation = { issueMicrosoftOAuthURL: { url: string } };

export type StoreMicrosoftOAuthCredentialForPlannerAccountMutationVariables = Exact<{
  code: string;
  redirectUri: string;
}>;


export type StoreMicrosoftOAuthCredentialForPlannerAccountMutation = { storePlannerAccountOAuthCredential: { __typename: 'StorePlannerAccountOAuthCredentialSuccessPayload' } };

export type RevokeMicrosoftOAuthTokenForPlannerAccountMutationVariables = Exact<{
  input: Types.RevokePlannerAccountThirdpartyOAuthCredentialsInput;
}>;


export type RevokeMicrosoftOAuthTokenForPlannerAccountMutation = { revokePlannerAccountThirdpartyOAuthCredentials: { __typename: 'RevokePlannerAccountThirdpartyOAuthCredentialsSuccessPayload' } };


export const IssueMicrosoftOAuthUrlDocument = gql`
    mutation issueMicrosoftOAuthUrl($redirectUri: String!) {
  issueMicrosoftOAuthURL(redirectURL: $redirectUri) {
    url
  }
}
    `;

/**
 * __useIssueMicrosoftOAuthUrlMutation__
 *
 * To run a mutation, you first call `useIssueMicrosoftOAuthUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueMicrosoftOAuthUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueMicrosoftOAuthUrlMutation({
 *   variables: {
 *     redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useIssueMicrosoftOAuthUrlMutation(options: VueApolloComposable.UseMutationOptions<IssueMicrosoftOAuthUrlMutation, IssueMicrosoftOAuthUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueMicrosoftOAuthUrlMutation, IssueMicrosoftOAuthUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueMicrosoftOAuthUrlMutation, IssueMicrosoftOAuthUrlMutationVariables>(IssueMicrosoftOAuthUrlDocument, options);
}
export type IssueMicrosoftOAuthUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueMicrosoftOAuthUrlMutation, IssueMicrosoftOAuthUrlMutationVariables>;
export const StoreMicrosoftOAuthCredentialForPlannerAccountDocument = gql`
    mutation storeMicrosoftOAuthCredentialForPlannerAccount($code: String!, $redirectUri: String!) {
  storePlannerAccountOAuthCredential(
    input: {provider: MICROSOFT, code: $code, redirectUri: $redirectUri}
  ) {
    __typename
  }
}
    `;

/**
 * __useStoreMicrosoftOAuthCredentialForPlannerAccountMutation__
 *
 * To run a mutation, you first call `useStoreMicrosoftOAuthCredentialForPlannerAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStoreMicrosoftOAuthCredentialForPlannerAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStoreMicrosoftOAuthCredentialForPlannerAccountMutation({
 *   variables: {
 *     code: // value for 'code'
 *     redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useStoreMicrosoftOAuthCredentialForPlannerAccountMutation(options: VueApolloComposable.UseMutationOptions<StoreMicrosoftOAuthCredentialForPlannerAccountMutation, StoreMicrosoftOAuthCredentialForPlannerAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StoreMicrosoftOAuthCredentialForPlannerAccountMutation, StoreMicrosoftOAuthCredentialForPlannerAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StoreMicrosoftOAuthCredentialForPlannerAccountMutation, StoreMicrosoftOAuthCredentialForPlannerAccountMutationVariables>(StoreMicrosoftOAuthCredentialForPlannerAccountDocument, options);
}
export type StoreMicrosoftOAuthCredentialForPlannerAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StoreMicrosoftOAuthCredentialForPlannerAccountMutation, StoreMicrosoftOAuthCredentialForPlannerAccountMutationVariables>;
export const RevokeMicrosoftOAuthTokenForPlannerAccountDocument = gql`
    mutation revokeMicrosoftOAuthTokenForPlannerAccount($input: RevokePlannerAccountThirdpartyOAuthCredentialsInput!) {
  revokePlannerAccountThirdpartyOAuthCredentials(input: $input) {
    __typename
  }
}
    `;

/**
 * __useRevokeMicrosoftOAuthTokenForPlannerAccountMutation__
 *
 * To run a mutation, you first call `useRevokeMicrosoftOAuthTokenForPlannerAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMicrosoftOAuthTokenForPlannerAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeMicrosoftOAuthTokenForPlannerAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRevokeMicrosoftOAuthTokenForPlannerAccountMutation(options: VueApolloComposable.UseMutationOptions<RevokeMicrosoftOAuthTokenForPlannerAccountMutation, RevokeMicrosoftOAuthTokenForPlannerAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RevokeMicrosoftOAuthTokenForPlannerAccountMutation, RevokeMicrosoftOAuthTokenForPlannerAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RevokeMicrosoftOAuthTokenForPlannerAccountMutation, RevokeMicrosoftOAuthTokenForPlannerAccountMutationVariables>(RevokeMicrosoftOAuthTokenForPlannerAccountDocument, options);
}
export type RevokeMicrosoftOAuthTokenForPlannerAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RevokeMicrosoftOAuthTokenForPlannerAccountMutation, RevokeMicrosoftOAuthTokenForPlannerAccountMutationVariables>;